/* unplugin-vue-components disabled */import { render } from "./StepType2.vue?vue&type=template&id=52e8979a"
import script from "./StepType2.vue?vue&type=script&lang=js"
export * from "./StepType2.vue?vue&type=script&lang=js"

import exportComponent from "/home/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__